import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import firebase from 'firebase/compat';
import { uniq } from 'lodash';
import MessagePayload = firebase.messaging.MessagePayload;
import { ActionModal } from '../../../../shared/qplanning-commons/modals/action-modal.component';

@Component({
  selector: 'app-notification-modal',
  standalone: true,
  imports: [ActionModal, TranslateModule],
  template: `
    <qpc-action-modal
      [heading]="heading()"
      [actionButtonLabel]="actionText"
      (onAction)="this.onAction.emit()"
      (onCancel)="this.onCancel.emit()">
      @if (bodies().length === 1) {
        {{ bodies()[0] }}
      } @else {
        <ul>
          @for (body of bodies(); track body) {
            <li>{{ body }}</li>
          }
        </ul>
      }
    </qpc-action-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationModalComponent {
  readonly messagePayloads = input.required<MessagePayload[]>();

  readonly onAction = output();
  readonly onCancel = output();

  private readonly translateService = inject(TranslateService);

  readonly heading = computed(() => {
    const titles = uniq(this.messagePayloads().map((m) => m.notification.title));
    return titles.length === 1 ? titles.pop() : 'notification.push.MULTIPLE.title';
  });

  readonly bodies = computed(() => uniq(this.messagePayloads().map((m) => m.notification.body)));

  get actionText() {
    return this.translateService.instant('components.zenith.action-modal.navigateToPage');
  }
}
